module.exports = __webpack_public_path__ + "static/media/adminPanel.973a3216.png";